import React from 'react';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { ja } from 'date-fns/locale';
import { TextField, TextFieldProps } from '@mui/material';
import useBusinessDate from '../../hooks/useBusinessDate';

interface BusinessDatePickerProps {
  label?: string;
  value: Date | null;
  onChange: (date: Date | null) => void;
  disabled?: boolean;
  required?: boolean;
  fullWidth?: boolean;
  textFieldProps?: TextFieldProps;
  minDate?: Date;
  maxDate?: Date;
  className?: string;
  disableFuture?: boolean;
  disablePast?: boolean;
  format?: string;
}

/**
 * 営業終了時間を考慮した日付選択コンポーネント
 * 24:00以降で営業終了時間前の場合は前日の日付を表示する
 */
const BusinessDatePicker: React.FC<BusinessDatePickerProps> = ({
  label = '日付',
  value,
  onChange,
  disabled = false,
  required = false,
  fullWidth = true,
  textFieldProps,
  minDate,
  maxDate,
  className,
  disableFuture = false,
  disablePast = false,
  format = 'yyyy/MM/dd'
}) => {
  const { businessDate, isLoading } = useBusinessDate();

  const displayValue = value ?? businessDate;

  const handleDateChange = (newDate: Date | null) => {
    onChange(newDate);
  };

  if (isLoading) {
    return (
      <TextField
        label={label}
        disabled
        value="読み込み中..."
        fullWidth={fullWidth}
        className={className}
        {...textFieldProps}
      />
    );
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ja}>
      <DatePicker
        label={label}
        value={displayValue}
        onChange={handleDateChange}
        disabled={disabled}
        format={format}
        minDate={minDate}
        maxDate={maxDate}
        disableFuture={disableFuture}
        disablePast={disablePast}
        slotProps={{
          textField: {
            required,
            fullWidth,
            className,
            ...textFieldProps,
          },
        }}
      />
    </LocalizationProvider>
  );
};

export default BusinessDatePicker; 